<template>
  <div>
    <b-row align-h="center" class="mt-2">
        <div v-if="bannerCount == 1">
            <b-col cols="12" md="8" lg="6">
                <div style="margin: 4px 8px 0px 0px;">
                    <b-img :src="getBanner(0)" fluid  @click="showModal=true"></b-img>
                </div>
            </b-col>
        </div>
        <div v-else>
            <b-col cols="12">
                <div style="margin: 4px 8px 0px 0px;">
                    <div class="d-block d-sm-none">
                        <b-img :src="getBanner(0)" fluid  @click="showModal=true"></b-img>
                    </div>
                    <div class="d-none d-sm-block d-md-none">
                        <b-img :src="getBanner(2)" fluid  @click="showModal=true"></b-img>
                    </div>
                    <div class="d-none d-md-block d-lg-none">
                        <b-img :src="getBanner(1)" fluid  @click="showModal=true"></b-img>
                    </div>
                    <div class="d-none d-lg-block d-xl-none">
                        <b-img :src="getBanner(2)" fluid  @click="showModal=true"></b-img>
                    </div>
                    <div class="d-none d-xl-block">
                        <b-img :src="getBanner(3)" fluid  @click="showModal=true"></b-img>
                    </div>
                </div>
            </b-col>
        </div>
    </b-row>
    <div v-if="debug" class="text-center font-weight-bold">
        <!-- Grid sizes:  https://getbootstrap.com/docs/4.4/layout/overview/  -->
        <!-- Display Utilities:  https://getbootstrap.com/docs/4.4/utilities/display/  -->
        <div class="d-block d-sm-none">XS</div>
        <div class="d-none d-sm-block d-md-none">SM</div>
        <div class="d-none d-md-block d-lg-none">MD</div>
        <div class="d-none d-lg-block d-xl-none">LG</div>
        <div class="d-none d-xl-block">XL</div>
    </div>
    <b-row v-if="debug" align-h="center" class="mt-2">
      <b-col cols="12">
        <div style="margin: 4px 8px 0px 0px;">
          <b-img :src="getBanner(0)" fluid></b-img>
        </div>
      </b-col>
      <b-col cols="12">
        <div style="margin: 4px 8px 0px 0px;">
          <b-img :src="getBanner(1)" fluid></b-img>
        </div>
      </b-col>
      <b-col cols="12">
        <div style="margin: 4px 8px 0px 0px;">
          <b-img :src="getBanner(2)" fluid></b-img>
        </div>
      </b-col>
      <b-col cols="12">
        <div style="margin: 4px 8px 0px 0px;">
          <b-img :src="getBanner(3)" fluid></b-img>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"

export default {
  name: "MobileAdTest",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: '',
      busy: true,
      submitted: false,
      haveMobileAd: false,
      mobileBanners: null,
      bannerCount: 0,
      mobileAd: {buttonText: 'Click here', blurb: 'Text forthcoming'},
      studentHash: this.$root.getToken(),
    }
  },
  props: {
    mb: {  // mobileAd banner object
      type: Object
    },
  },
  computed: {
},
  methods: {
    getBanner(ix) {
      return this.mobileBanners.adUrls[ix]
    }
  },
  created() {
    // console.log(this.mb)
    this.mobileBanners = this.mb || {adId: 0, adUrls: []}
    this.bannerCount = this.mobileBanners.adUrls.length
  },
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
  .txt-cert-title1 {
    font-size: .9rem;
    font-weight: bold;
  }
  .txt-cert-title2 {
    font-size: 1.2rem;
    font-weight: bold;
  }
  .div-cert-body {
    text-align: left;
    font-size: .9rem;
  }
  .div-cert-footer {
    text-align: left;
    font-size: .6rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/MobileAdTest.vue